import script from "./WechatSliderGate.vue?vue&type=script&setup=true&lang=ts"
export * from "./WechatSliderGate.vue?vue&type=script&setup=true&lang=ts"

import "./WechatSliderGate.vue?vue&type=style&index=0&id=4ceb656c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ceb656c"]])

export default __exports__